import React from "react";
import { MANAGED_SERVICES_TIER } from "constants/companies";

/**
 * Company tier pill. Managed Services gets the violet tone (tinted fill +
 * leading dot, same treatment as the status pills) so it reads at a glance
 * against the gray of every other tier (CPO 2026-11-03). Other tiers stay
 * muted on purpose — only Managed Services needs to stand out.
 */
export default function TierBadge({ tier, className = "" }) {
  if (!tier) return null;
  if (tier === MANAGED_SERVICES_TIER) {
    return (
      <span className={`badge-violet ${className}`.trim()}>
        <span className="h-1.5 w-1.5 rounded-full bg-violet" aria-hidden="true" />
        {tier}
      </span>
    );
  }
  return <span className={`badge-muted capitalize ${className}`.trim()}>{tier}</span>;
}
